<template>
    <div class="title">
      <div class="title-content">
        <img :src="info.ico" :width="info.width" :height="info.height"/>
        <span>{{info.text}}</span>
        <span>/</span>
        <P>{{info.english}}</P>
      </div>
      <div class="title-bg"></div>
    </div>
</template>

<script>
    export default {
        name: "Title",
      props: ['info'],
    }
</script>

<style scoped lang="less">
  .title{
    width: 100%;
    height: 28vh*0.098;
    padding-left: 6px;
    padding-right: 10px;
    box-sizing: border-box;
    position: relative;
    .title-content{
      display: flex;
      align-items: flex-end;
      align-items: center;
      img{

        margin-right: 5px;
      }
      span{
        font-size: 16px;
        color: #fff;
        font-weight: bold;
      }
      p{
        color: #c9c9c9;
        font-size: 12px;
        transform: scale(0.8);
      }
    }
    .title-bg{
      position: absolute;
      bottom: 0;
      width: 340px;
      height: 5vh*.0926;
      background: url("./../assets/title-bg.png") no-repeat;
      background-size: 100% 100%;
    }
  }
</style>
